// extracted by mini-css-extract-plugin
export default {"root":"Pointer_root__4Mhcp","movein":"Pointer_movein__W0xUY"};